/**
 * Checks if a value is a valid hexadecimal string.
 * @param value - The value to be checked.
 * @param options - Optional configuration for the validation.
 * @returns True if the value is a valid hexadecimal string, false otherwise.
 * @example
 * ```ts
 * import { isHex } from "thirdweb/utils";
 * const result = isHex("0x1a4");
 * console.log(result); // true
 * ```
 * @utils
 */
export function isHex(value, options = {}) {
    if (!value) {
        return false;
    }
    if (typeof value !== "string") {
        return false;
    }
    return options.strict
        ? /^0x[0-9a-fA-F]*$/.test(value)
        : value.startsWith("0x");
}
//# sourceMappingURL=is-hex.js.map